<template>
  <div class="col-12 c g">
    <div class="card card-body">
        <div class="col-12 table-responsive">
            <table class="table table-hover table-bordered table-sm">
                <thead>
                    <th>
                        العنوان
                    </th>
                    <th>
                        التاريخ
                    </th>
                    <th>
                        الحالة
                    </th>
                    <th>
                        الرد
                    </th>
                </thead>
                <tbody>
                    <tr v-for="h in mails" :key="h._id">
                        <td>
                            {{ h.title }}
                        </td>
                        <td>
                            {{ h.date }}
                        </td>
                        <td>
                            <span class="text-danger" v-if="h.reply == ''">لم يتم الرد</span>
                            <span class="text-success" v-if="h.reply != ''">تم الرد</span>
                        </td>
                        <td>
                            <a :href="`https://s.tahdir.net/mail/${h._id}/${h.teacher_id}`" target="_blank" class="btn btn-sm btn-primary" v-if="h.reply == ''">
                                <i class="fa fa-external-link"></i>
                                رد الآن
                            </a>
                            <span v-if="h.reply != ''">
                                <a :href="`https://s.tahdir.net/mail/${h._id}/${h.teacher_id}`" target="_blank" class="btn btn-sm btn-primary">
                                    <i class="fa fa-external-link"></i>
                                    عرض التعميم
                                </a>
                                {{ h.reply }}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
  </div>
</template>

<script>
import { BFormCheckbox } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
export default {
    components: {
        BFormCheckbox,
    },
    directives: {
        Ripple,
    },
    data(){
        return {
            teacher: JSON.parse(localStorage.getItem('teacher')),
            mails: []
        }
    },
    created(){
        var g = this;
        $.post(api + '/teacher/mails', {
            username: this.teacher.username,
            password: this.teacher.password
        }).then(function(r){
            g.loading = false
            if(r.status != 100){
                alert(r.response)
            }else{
                g.mails = r.response;
            }
        }).fail(function(){
        })
    },
    methods: {
    }
}
</script>

<style>
.classroom{
    padding: 15px; 
    border: 2px solid #ddd;
    border-radius: 5px;
}
.classroom:hover{
    background: #fafafa !important;
    cursor: pointer;
    border: 2px solid #333;
}
</style>